// extracted by mini-css-extract-plugin
export default {"sort_arrows_container":"styles_sort_arrows_container__QqmEu"};